import { css } from 'lit';

export default css`
  :host {
    display: inline-flex;
  }

  .badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: max(12px, 0.75em);
    font-weight: var(--webmodule-font-weight-semibold);
    letter-spacing: var(--webmodule-letter-spacing-normal);
    line-height: 1;
    border-radius: var(--webmodule-border-radius-medium);
    border: solid 1px var(--webmodule-color-neutral-0);
    white-space: nowrap;
    padding: var(--webmodule-spacing-2x-small) var(--webmodule-spacing-small)
      calc(var(--webmodule-spacing-x-small) - 2px) var(--webmodule-spacing-small);
    user-select: none;
    cursor: inherit;
  }

  /* Variant modifiers */
  .badge--primary {
    background-color: var(--webmodule-color-primary);
    color: var(--webmodule-color-neutral-0);
  }

  .badge--success {
    background-color: var(--webmodule-color-success);
    color: var(--webmodule-color-neutral-0);
  }

  .badge--neutral {
    background-color: var(--webmodule-color-neutral-600);
    color: var(--webmodule-color-neutral-0);
  }

  .badge--warning {
    background-color: var(--webmodule-color-warning);
    color: var(--webmodule-color-neutral-0);
  }

  .badge--danger {
    background-color: var(--webmodule-color-danger);
    color: var(--webmodule-color-neutral-0);
  }

  .badge--pill {
    border-radius: var(--webmodule-border-radius-pill);
  }

  .badge--pulse {
    animation: pulse 1.5s infinite;
  }

  .badge--pulse.badge--primary {
    --pulse-color: var(--webmodule-color-primary);
  }

  .badge--pulse.badge--success {
    --pulse-color: var(--webmodule-color-success);
  }

  .badge--pulse.badge--neutral {
    --pulse-color: var(--webmodule-color-neutral-600);
  }

  .badge--pulse.badge--warning {
    --pulse-color: var(--webmodule-color-warning);
  }

  .badge--pulse.badge--danger {
    --pulse-color: var(--webmodule-color-danger);
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 var(--pulse-color);
    }
    70% {
      box-shadow: 0 0 0 0.5rem transparent;
    }
    100% {
      box-shadow: 0 0 0 0 transparent;
    }
  }
`;
